<template>
  <wallet-form-shell>
    <div v-if="submitted">
      <wallet-form-header
        :title="title"
        :message="message"
      />
    </div>
    <div v-else>
      <wallet-form
        :form-type="formType"
        :loading="loading"
        @form-submit="sendReset"
      />
      <v-btn
        id="back-button"
        color="primary"
        text
        exact
        :to="loginRoute"
        class="ma-0 no-uppercase"
      >
        <v-icon>
          mdi-chevron-left
        </v-icon>
        {{ $t('wallet.login.back-to-login-button-label') }}
      </v-btn>
    </div>
  </wallet-form-shell>
</template>

<script>
import WalletFormShell from '@/components/wallet/WalletFormShell'
import WalletForm from '@/components/wallet/WalletForm'
import WalletFormHeader from '@/components/wallet/WalletFormHeader'
import { WalletFormType } from '@/components/wallet/wallet-form-type'
import { WALLET_LOGIN_ROUTE } from '@/router/routes/route-names'
import { WalletApi } from '@/cowboy/wallet/WalletApi'

export default {
  name: 'RecoverPassword',
  components: {
    WalletFormShell,
    WalletForm,
    WalletFormHeader
  },
  data () {
    return {
      loading: false,
      submitted: false,
      emailAddress: null
    }
  },
  computed: {
    formType () {
      return WalletFormType.PASSWORD_RECOVERY
    },
    loginRoute () {
      return { name: WALLET_LOGIN_ROUTE }
    },
    title () {
      return this.$t('wallet.recover.title-submitted')
    },
    message () {
      return this.$t('wallet.recover.message-submitted', {
        email: this.emailAddress
      })
    }
  },
  methods: {
    async sendReset ({ emailAddress }) {
      this.loading = true
      this.emailAddress = emailAddress
      try {
        await WalletApi.forgotPassword(emailAddress)
        this.submitted = true
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
